import * as React from 'react';
import Icon from '../../icons';
const moment = require('moment');
import ComponentVisible from '../ComponentVisible';
import { useSelector, shallowEqual } from "react-redux";
import LoaderComponent from '../Loader';
import CalendarPicker from '../FieldEngine/FieldTypes/CalendarPicker';
import FormSelectSearch from '../FormComponents/formSelectSearch';
import { MAX_DATE_ARRAY_FIELDS, DATE_FORMAT, TIME_FORMAT, MIN_DATE_ARRAY_FIELDS } from "../../containers/WorkkardDetail/constants";
import { DEFAULT_TIME_FORMAT, DEFAULT_DATE_FORMAT } from '../../common/constants';
import * as CommonUtil from '../../common/util';

var payload = {}, preparedCompositeFieldData = {}, loaderForField = "", emailRegex = new RegExp(/^([A-Za-z0-9_\-\.])+\@([A-Za-z\-])+\.([A-Za-z]{2,4})$/);
const isSettingEnabled = (setting) => {
    const value = setting !== null && typeof setting === 'object' ? setting.default : setting;
    return value === true || value === 'true';
};

const InlineEditableField = (props) => {
    const { data } = props;

    const { ref, isVisible, setIsVisible } = ComponentVisible(false);
    const [text, setText] = React.useState(null);
    const [isHover, setHover] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [pendingDateValues, setPendingDateValues] = React.useState({});

    const { isLoading } = useSelector(state => ({
        isLoading: state.workkardDetail.detailPage.isLoading
    }), shallowEqual);

    const tzList = useSelector(state => state?.sessionContextOidc?.tzData ?? []);

    React.useEffect(() => {
        if (isVisible) {
            if (!props.isCompositeField && props.data.PreInitScript) {
                eval(props.data.PreInitScript);
            }
            else if (props.isCompositeField && props.combinedData && props.combinedData.length > 0) {
                props.combinedData.map(item => {
                    eval(item.PreInitScript);
                });
            }
        }
        else if (!isVisible) {
            payload = {};
            preparedCompositeFieldData = {};
            setError(false);
            setText(null);
            setPendingDateValues({});
        }
    }, [isVisible]);

    React.useEffect(() => {
        if (!isLoading && loaderForField != "") {
            loaderForField = "";
        }
    }, [isLoading]);

    const selectedItem = (data) => {
        let option = data.option, selectedItem = "";
        if (option.hasOwnProperty("Item1")) {
            selectedItem = option.Item1;
        }
        else if (option.hasOwnProperty("Name")) {
            selectedItem = option.Name

        } else {
            selectedItem = option.Value
        }

        setText(selectedItem);

    }

    const setStateOnHover = () => {
        if (!data.IsNonEditable && props.canEdit) {
            setHover(true);
        }
    }

    const onFocus = (e) => {
        if ($(`[data-compositeField-id^=${e.target.name}]`).hasClass("errorMsg")) {
            $(`[data-compositeField-id^=${e.target.name}]`).removeClass("errorMsg");
        }
        props.removeErrorOnFocus(e);
    }


    const onEditClick = (value) => {
        if (props.data.IsNonEditable || !props.canEdit || isLoading) {
            return
        }
        if (!props.isCompositeField) {
            setText(value == "-" ? "" : value);
        }
        setIsVisible(true);
    }

    const closeEditField = () => {
        setIsVisible(false);
        setText(data.hasOwnProperty('dataValue') ? data.dataValue : props.fieldValue);
    }

    const validateField = () => {
        let isValid = true;
        if (props.data.IsRequired && text.trim() == "" || props.data.IsRequired && text.trim() == "-1") {
            $('#' + props.data.FieldKey + 'errorBlock').text(props.data.Label + ' is required.');
            isValid = false;
            setError(true);
            return isValid;
        }
        if (text.trim() != "") {
            switch (props.type) {
                case 'email':
                    let inputValue = text.trim();
                    let isValidEmail = emailRegex.test(inputValue);
                    if (!isValidEmail) {
                        $('#' + props.data.FieldKey + 'errorBlock').text('Invalid email.')
                        isValid = isValidEmail;
                        setError(true);
                    }
                    return isValid;        
                default:
                    break;
            }
        }
        if (props.data.PreSaveScript) {
            try {
                const result = eval(props.data.PreSaveScript);
                if (typeof (result) == "boolean") {
                    isValid = result;
                } else if (typeof (result) == "object") {
                    isValid = result.hasOwnProperty("flag") ? result.flag : isValid;
                    if (result.dependentField.length > 0) {
                        result.dependentField.map(item => {
                            payload[item.field] = item.value;
                        });
                    }
                }
            } catch (e) {
                console.log('PreSaveScript execution failed for field', props.data.FieldKey, e);
            }
            if (!isValid) {
                setError(true);
            }
        }
        return isValid;

    }

    const getTitle=(options)=>{
        let title;
        if(options.length >0){
            if(options[0].hasOwnProperty("Item1")){
                title= options[0].Item2
   
            }
            else if(options[0].hasOwnProperty("Name")){
                title= options[0].Name 
   
            }
           return title;   
    }
}

    const updateField = () => {
        if (isLoading) return;
        payload = {};
        let isValid = validateField();
        if (isValid && $('#' + props.data.FieldKey + 'errorBlock').is(':empty')) {
            payload[props.data.Name] = props.type == "decimal" ? $(`[id^=${props.data.FieldKey}`).val().toString().trim().replace(/,/g, '') : text.toString().trim()
            props.updateField(payload);
            loaderForField = data.FieldKey;
            setIsVisible(false);
        }
    }


    const renderFieldValue = () => {
        if (isLoading && loaderForField.includes(data.FieldKey)) {
            return (<div className="skletonLoader"><span><LoaderComponent /></span></div>)
        } else {
            return (<div className={isHover ? 'InlineHover' : ''} data-field-value={data.FieldKey} data-field-name={data.Name} onMouseEnter={() => setStateOnHover()} onMouseLeave={() => setHover(false)} onClick={() => onEditClick(data.hasOwnProperty('dataValue') ? data.dataValue : props.fieldValue)}>{props.fieldValue}</div>);
        }
    }

    const renderEditableField = () => {
        switch (props.type) {
            case "string":
            case "email":
            case "number":
                return renderInputField();
            case "decimal":
                return renderDecimalField();
            case "singlechoicelist":
                return renderDropdownField();
            case "date":
                return renderDateField(props.data);
            case "searchDropdown":
                return renderSearchDropdown();
            case "datetimetimezone":
            case "name":
                return renderCompositeField();
            default:
                break;
        }

    }

    const renderInputField = () => {
        return (<div className={`InlineEditBlock rowSpaceBetween colFlex formGroup ${isError ? "errorMsg" : ''}`}>
            <input type="text" id={data.FieldKey} name={data.FieldKey} placeholder={data.Label} maxLength={data.MaxLength != 0 && data.MaxLength} value={text} onFocus={(e) => { if (isError) { setError(false) } props.removeErrorOnFocus(e) }} onChange={(e) => setText(e.target.value)} autoFocus={true} />
            <div className="customEdit carrierCheck rowSpaceBetween">
                <span className="statusCheck mr__1" onClick={() => updateField()}><Icon name="check" className={`icon activeIcon check`} /></span>
                <span onClick={() => closeEditField()} ><Icon name="close" className="icon close" /></span>
            </div>
            <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
        </div>
        )
    }

    const renderDecimalField = () => {
        return (<div className={`InlineEditBlock colFlex formGroup ${isError ? "errorMsg" : ''}`}>
            <div className="rowSpaceBetween flexGrow">
                <input type="text" id={data.FieldKey} name={data.FieldKey} placeholder={data.Label} maxLength={data.MaxLength != 0 && data.MaxLength} defaultValue={data.Value} onFocus={(e) => { if (isError) { setError(false) } props.removeErrorOnFocus(e) }} autoFocus={true} />
                <div className="customEdit carrierCheck rowSpaceBetween">
                    <span className="statusCheck mr__1" onClick={() => updateField()}><Icon name="check" className={`icon activeIcon check`} /></span>
                    <span onClick={() => closeEditField()} ><Icon name="close" className="icon close" /></span>
                </div>
            </div>
            <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
        </div>
        )
    }

    const renderDropdownField = () => {
        let optionItems = data.Options.map((element) =>
            <option key={element.Id || element.Item1} value={element.Value || element.Item1 || element.Name} selected={data.Value == element.Value || element.Item1 || element.Name ? true : false}>{element.DisplayName || element.Item2 || element.Name}</option>
        );

        return (
            <div className={`InlineEditBlock colFlex formGroup ${isError ? "errorMsg" : ''}`}>
                <div className="rowSpaceBetween flexGrow">
                    <select type="text" id={data.FieldKey} name={data.FieldKey} value={text} onFocus={(e) => { if (isError) { setError(false) } props.removeErrorOnFocus(e) }} onChange={(e) => setText(e.target.value)} >
                        {optionItems}
                    </select>
                    <div className="carrierCheck rowSpaceBetween ml">
                        <span className="statusCheck mr__1" onClick={() => updateField()}><Icon name="check" className={`icon activeIcon check`} /></span>
                        <span id={data.FieldKey + "closeEditBlock"} onClick={() => closeEditField()} ><Icon name="close" className="icon close" /></span>
                    </div>
                </div>
                <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
            </div>
        );

    }

    const renderDateField = (data) => {
        let futureDate, pastDate;
        var dateFieldArray = MAX_DATE_ARRAY_FIELDS;
        dateFieldArray.forEach((element) => {
            if (data.Label == element) {
                futureDate = moment()
            }
        });
        var pastDateFields = MIN_DATE_ARRAY_FIELDS;
        pastDateFields.forEach((element) => {
            if (data.Label == element) {
                pastDate = moment()
            }
        });
        const fieldSetting = data.FieldSettings ? JSON.parse(data.FieldSettings) : {};
        const showTime = !props.timezoneAsCaption && isSettingEnabled(fieldSetting.input_time_component);
        const format = showTime ? TIME_FORMAT : DATE_FORMAT;
        const initialMoment = data.Value ? moment.utc(data.Value) : null;
        const initialIsoValue = initialMoment && initialMoment.isValid()
            ? initialMoment.format(showTime ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD')
            : null;
        const isoValue = pendingDateValues.hasOwnProperty(data.FieldKey)
            ? pendingDateValues[data.FieldKey]
            : initialIsoValue;
        return (
            <div data-compositeField-id={data.FieldKey} className={`InlineEditBlock colFlex wth-12 formGroup`}>
                <div className="alignMiddle" onFocus={(e) => onFocus(e)}>
                    <CalendarPicker
                        id={data.FieldKey}
                        value={isoValue}
                        minDate={pastDate ? pastDate.format('YYYY-MM-DD') : undefined}
                        maxDate={futureDate ? futureDate.format('YYYY-MM-DD') : undefined}
                        disabled={data.disabled}
                        showTime={showTime}
                        onChange={(iso) => {
                            const formatted = iso && moment(iso).isValid() ? moment(iso).format(format) : "";
                            setPendingDateValues(prev => ({ ...prev, [data.FieldKey]: iso }));
                            onFieldValueChange({ name: data.FieldKey, value: formatted });
                            if (!props.isCompositeField) setText(formatted);
                        }}
                        onConfirm={props.isCompositeField ? () => updateCompositeField() : () => updateField()}
                        onCancel={props.isCompositeField ? () => setIsVisible(false) : () => closeEditField()}
                        caption={props.isCompositeField && props.timezoneAsCaption ? getCompositeTimezoneText() : undefined}
                        extra={props.isCompositeField && !props.timezoneAsCaption ? renderCompositeTimezoneSelect() : undefined}
                    />
                </div>
                <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
            </div>);

    }

    const renderSearchDropdown = () => {
        return (
            <div className={`InlineEditBlock colFlex wth-12 formGroup ${isError ? "errorMsg" : ''}`}>
                <div className="alignMiddle">
                    <FormSelectSearch
                        Id={data.FieldKey}
                        iconName="chev"
                        openOnHover={false}
                        openOnClick={true}
                        onFocus={(e) => { if (isError) { setError(false) } props.removeErrorOnFocus(e) }}
                        styleClass="icon"
                        widthClass=""
                        selected={text}
                        onSelect={(data) => selectedItem(data)}
                        title={text === "" ? getTitle(data.Options) : text}
                        name={data.Name}
                        options={data.Options}
                        data={data.Value}
                        isDisabled={data.IsNonEditable}
                        wrapperClass=""
                        className=""
                    />
                    <div className="carrierCheck rowSpaceBetween ml">
                        <span className="statusCheck mr__1" onClick={() => updateField()}><Icon name="check" className={`icon activeIcon check`} /></span>
                        <span onClick={() => closeEditField()} ><Icon name="close" className="icon close" /></span>
                    </div>
                </div>
                <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
            </div>);

    }

    const getItemValue = (data) => {
        if (data.FieldType == "timezone") {
            const matchedTz = tzList.find(item => item.mapped_time_zone === data.Value || item.standard_time_zone === data.Value || item.display_value === data.Value);
            return matchedTz?.standard_time_zone;
        }
        else if(data.FieldKey=="dueDate")
        return data.Value.format(DEFAULT_TIME_FORMAT);
    }

    //composite Field rendering
    const renderCompositeField = () => {
        if (props.combinedData && props.combinedData.length > 0) {
            return (
                <div>
                    {props.combinedData.map(item => {
                        if (!preparedCompositeFieldData[item.FieldKey]) {
                            preparedCompositeFieldData[item.FieldKey] = { key: item.FieldKey, fieldName: item.Name, value:(typeof(item.Value)=="string" && item.Value.trim() || item.Value) ? (getItemValue(item) ?? "") : "", IsMandatory: item.IsRequired, PreSaveScript: item.PreSaveScript, FieldType: item.FieldType, Label: item.Label };
                        }
                        return renderEditableCompositeField(item);
                    })}
                    {!props.combinedData.some(item => item.FieldType == "datetime") && <div className='dateCheck alignMiddle'>
                        <span className="statusCheck mr__1" onClick={() => { updateCompositeField() }}><Icon name="check" className={`icon activeIcon check`} /></span>
                        <span onClick={() => setIsVisible(false)} ><Icon name="close" className="icon close" /></span>
                    </div>}
                </div>
            )

        }

    }

    const renderEditableCompositeField = (data) => {
        switch (data.FieldType) {
            case "string":
                return (<div>
                    <input type="text" id={data.FieldKey} name={data.FieldKey} placeholder={data.Label} maxLength={data.MaxLength != 0 && data.MaxLength} defaultValue={data.Value} onFocus={(e) => props.removeErrorOnFocus(e)} onChange={(e) => onFieldValueChange(e.target)} />
                    <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
                </div>)
            case "datetime":
                return renderDateField(data);
            case "timezone":
                return props.combinedData.some(item => item.FieldType == "datetime") ? null : renderTimezoneSelect(data, 'calc(100% - 62px)');
            default:
                break;
        }
    }

    const renderTimezoneSelect = (data, width) => {
        const fieldSetting = data.FieldSettings ? JSON.parse(data.FieldSettings) : {};
        const matchedTz = data.Value
            ? tzList.find(item => item.mapped_time_zone === data.Value || item.standard_time_zone === data.Value || item.display_value === data.Value)
            : null;
        let selectedOption = matchedTz ? matchedTz.standard_time_zone : props.userTimezone;
        let optionItems = tzList.map((element) =>
            <option key={element.id} value={element.standard_time_zone} selected={(selectedOption == element.standard_time_zone) ? true : false}>{element.display_value}</option>
        );
        return (
            <div data-compositeField-id={data.FieldKey} className={`InlineEditBlock colFlex formGroup`}>
                <div className="invalidDate" style={{ width }}>
                    <select type="text" id={data.FieldKey} name={data.FieldKey} disabled={fieldSetting.timezone_iseditable === undefined ? false : !fieldSetting.timezone_iseditable} onFocus={(e) => onFocus(e)} onChange={(e) => { onFieldValueChange(e.target); }} >
                        {optionItems}
                    </select>
                </div>
                <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
            </div>
        );
    }

    const renderCompositeTimezoneSelect = () => {
        const timezoneItem = (props.combinedData || []).find(item => item.FieldType == "timezone");
        return timezoneItem ? renderTimezoneSelect(timezoneItem, '100%') : undefined;
    }

    const getCompositeTimezoneText = () => {
        const timezoneItem = (props.combinedData || []).find(item => item.FieldType == "timezone");
        if (!timezoneItem || !timezoneItem.Value) return undefined;
        const matchedTz = tzList.find(item => item.mapped_time_zone === timezoneItem.Value || item.standard_time_zone === timezoneItem.Value || item.display_value === timezoneItem.Value);
        return matchedTz ? matchedTz.display_value : timezoneItem.Value;
    }

    const onFieldValueChange = (e) => {
        const fieldStates = { ...preparedCompositeFieldData };
        const changedStateValue = {}
        changedStateValue[e.name] = Object.assign({}, fieldStates[e.name], { value: e.value })
        preparedCompositeFieldData = Object.assign({}, fieldStates, changedStateValue);
    }

    const validateIndividualFields = (key) => {
        let isValid = true;
        if (preparedCompositeFieldData[key].IsMandatory) {
            if (preparedCompositeFieldData[key].value.trim() == "" || preparedCompositeFieldData[key].value.trim() == "-1") {
                $('#' + preparedCompositeFieldData[key].key + 'errorBlock').text(preparedCompositeFieldData[key].Label + ' is required.')
                $(`[data-compositeField-id=${preparedCompositeFieldData[key].key}]`).addClass("errorMsg");
                isValid = false;
            } else {
                $('#' + preparedCompositeFieldData[key].key + 'errorBlock').text('');
            }
        }
        if (preparedCompositeFieldData[key].value != "" && preparedCompositeFieldData[key].value != null) {
            switch (preparedCompositeFieldData[key].FieldType) {
                case 'email':
                    let inputValue = preparedCompositeFieldData[key].value.trim();
                    let isValidEmail = emailRegex.test(inputValue);
                    if (!isValidEmail) {
                        $('#' + preparedCompositeFieldData[key].key + 'errorBlock').text(preparedCompositeFieldData[key].Label + ' is invalid.');
                        $(`[data-compositeField-id=${preparedCompositeFieldData[key].key}]`).addClass("errorMsg");
                        isValid = isValidEmail;
                    } else {
                        $('#' + preparedCompositeFieldData[key].key + 'errorBlock').text('')
                    }
                    break;
                case 'datetime':
                let inputDateTime = preparedCompositeFieldData[key].value.trim();
                let date = moment(inputDateTime, DEFAULT_DATE_FORMAT);
                if(CommonUtil.isInValidDate(date))
                {
                    $('#' + preparedCompositeFieldData[key].key + 'errorBlock').text(preparedCompositeFieldData[key].Label + ' is invalid.');
                    $(`[data-compositeField-id=${preparedCompositeFieldData[key].key}]`).addClass("errorMsg");
                    isValid=false;
                }
                else {
                    $('#' + preparedCompositeFieldData[key].key + 'errorBlock').text('')
                }
                    break;
                default:
                    break;
            }
        }
        if (isValid && preparedCompositeFieldData[key].PreSaveScript) {
            try {
                isValid = eval(preparedCompositeFieldData[key].PreSaveScript);
            } catch (e) {
                console.log('PreSaveScript execution failed for field', preparedCompositeFieldData[key].key, e);
                isValid = true;
            }
            !isValid ? $(`[data-compositeField-id=${preparedCompositeFieldData[key].key}]`).addClass("errorMsg") : null;
        }
        return isValid;
    }

    const ValidateCompositeField = () => {
        let isValid = true;
        if (Object.keys(preparedCompositeFieldData).length > 0) {
            for (let key in preparedCompositeFieldData) {
                if (!validateIndividualFields(key)) {
                    isValid = false
                }
            }
        }
        return isValid
    }

    const updateCompositeField = () => {
        if (isLoading) return;
        payload = {};
        const isValid = ValidateCompositeField();
        if (isValid) {
            for (let key in preparedCompositeFieldData) {
                const preparedField = preparedCompositeFieldData[key];
                const preparedValue = (preparedField.value ?? "").trim();
                if (preparedField.FieldType == "timezone" && preparedValue == "") continue;
                payload[preparedField.fieldName] = preparedValue;
            }
            props.updateField(payload);
            loaderForField = data.FieldKey;
            setIsVisible(false);
        }
    }

    //render
    return (
        <div ref={ref}>
            {!isVisible ? renderFieldValue() : renderEditableField()}
        </div>
    );
};


export default InlineEditableField;   